import {
  Typography as MuiTypography,
  type TypographyProps as MuiTypographyProps,
} from '@mui/material';
import type { FC } from 'react';

export type TypographyProps = Pick<
  MuiTypographyProps,
  'children' | 'variant' | 'color' | 'onClick' | 'component' | 'sx' | 'title'
>;

export const Typography: FC<TypographyProps> = ({ children, ...rest }) => (
  <MuiTypography {...rest}>{children}</MuiTypography>
);
